import ArrowRight from '@icon/variable/arrow-right.svg'
import { cn } from '@utils'
import { ButtonProps } from './button.types'
import {
  ButtonSize,
  ButtonTheme,
  getButtonOutlineClass,
  getButtonSizeClass,
  getButtonThemeClass,
} from './button.utils'

export default function Button({
  children,
  type = 'button',
  theme = ButtonTheme.DEFAULT,
  size = ButtonSize.MEDIUM,
  outline = false,
  bold = false,
  loading = false,
  bgTransparent = false,
  className,
  arrow = false,
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        'transition-colors',
        { 'cursor-pointer': !loading },
        getButtonThemeClass(theme, bold, bgTransparent),
        getButtonSizeClass(size),
        getButtonOutlineClass(outline, theme),
        className
      )}
      disabled={loading}
      {...props}
    >
      {loading ? (
        'loading...'
      ) : (
        <>
          {children}
          {arrow && (
            <ArrowRight
              width={bold ? 12 : 10}
              height={bold ? 12 : 10}
              className='fill-current ml-2 -translate-y-0.25'
            />
          )}
        </>
      )}
    </button>
  )
}
